import styled from '@emotion/styled';
import { Button } from '@mui/material';

// ===============================================
// 버튼 스타일 컴포넌트
// ===============================================
const BUTTON_SIZES = {
  small: {
    padding: '4px 8px',
    fontSize: '12px',
    minWidth: '60px',
    width: 'fit-content',
  },
  medium: {
    padding: '6px 16px',
    fontSize: '14px',
    minWidth: '100px',
  },
  large: {
    padding: '8px 24px',
    fontSize: '16px',
    minWidth: '140px',
  },
  custom: {
    padding: '10px 30px',
    fontSize: '16px',
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
  },
};

// ===============================================
// 버튼 폰트 굵기 설정
// ===============================================
const BUTTON_WEIGHTS = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

// ===============================================
// 버튼 색상 설정
// ===============================================
const BUTTON_COLORS = {
  primary: {
    main: '#1976d2',
    hover: '#1565c0',
    contrastText: '#fff',
  },
  secondary: {
    main: '#9c27b0',
    hover: '#7b1fa2',
    contrastText: '#fff',
  },
  success: {
    main: '#2e7d32',
    hover: '#1b5e20',
    contrastText: '#fff',
  },
  error: {
    main: '#d32f2f',
    hover: '#c62828',
    contrastText: '#fff',
  },
  warning: {
    main: '#ed6c02',
    hover: '#e65100',
    contrastText: '#fff',
  },
  info: {
    main: '#0288d1',
    hover: '#01579b',
    contrastText: '#fff',
  },
  gray: {
    main: '#90a4ae',
    hover: '#607d8b',
    contrastText: '#fff',
  },
};

// 기본 버튼 스타일
export const CustomButton = styled(Button)(
  ({
    size = 'medium',
    color = 'primary',
    variant = 'contained',
    weight = 'regular',
    disabled,
    login,
    width,
    height,
    borderRadius,
  }) => ({
    ...BUTTON_SIZES[size],
    backgroundColor: variant === 'contained' ? BUTTON_COLORS[color].main : 'transparent',
    color: variant === 'contained' ? BUTTON_COLORS[color].contrastText : BUTTON_COLORS[color].main,
    border: variant === 'outlined' ? `1px solid ${BUTTON_COLORS[color].main}` : 'none',
    fontWeight: BUTTON_WEIGHTS[weight],
    borderRadius: borderRadius || (size === 'custom' ? '8px' : '4px'),
    textTransform: 'none',
    // 커스텀 width와 height가 제공된 경우 적용
    ...(width && { width }),
    ...(height && { height }),

    '&:hover': {
      backgroundColor:
        variant === 'contained'
          ? BUTTON_COLORS[color].hover
          : variant === 'outlined'
            ? `rgba(${BUTTON_COLORS[color].main}, 0.04)`
            : 'transparent',
      border: variant === 'outlined' ? `1px solid ${BUTTON_COLORS[color].hover}` : 'none',
    },

    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor:
        login === 'true' ? '#767676' : disabled && variant === 'contained' ? 'rgba(0, 0, 0, 0.12)' : 'transparent',

      color: login === 'true' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.26)',
      border: disabled && variant === 'outlined' ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
    },
  }),
);

export const CustomTabButton = styled(CustomButton)({
  fontSize: '14px',
  padding: '4px 12px',
  minWidth: 'unset',
  borderRadius: '4px',
  '&.MuiButton-contained': {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
});
